/* ============================================================
   sl-product-card  -  vanilla, zero-dependency behaviour
   Public API: window.SLCard.init(rootElement)
   ============================================================ */
(function () {
  "use strict";

  var NS = "sl";
  var WISH_KEY = "sl_wishlist";
  var ROTATE_MS = 3000;
  var SWIPE_MIN = 40;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var noHover = window.matchMedia && window.matchMedia("(hover: none)").matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  var checkSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="#E8D5A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "sl-toast";
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = checkSvg + "<span></span>";
    toastEl.querySelector("span").textContent = msg;
    // force reflow so the transition runs
    void toastEl.offsetWidth;
    toastEl.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2400);
  }

  /* ---------- wishlist store ---------- */
  function wishGet() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch (e) { return []; } }
  function wishSet(arr) { try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (e) {} }
  function paintWish(handle) {
    var on = wishGet().indexOf(handle) > -1;
    $$('[data-sl-wish="' + cssEscape(handle) + '"]').forEach(function (btn) {
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function cssEscape(s) { return String(s).replace(/["\\]/g, "\\$&"); }
  function paintAllWishes() { wishGet().forEach(paintWish); }

  /* ---------- gallery per card ---------- */
  function initGallery(card) {
    var media = $("[data-sl-media]", card);
    if (!media) return;
    var slides = $$("[data-sl-slide]", card);
    var dots = $$("[data-sl-dots] i", card);
    var idx = 0, timer = null, inView = false, hovering = false;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === idx); });
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }

    function running() { return inView && (noHover || hovering); }
    function start() {
      if (reduceMotion || timer || slides.length < 2) return;
      if (!running()) return;
      timer = setInterval(next, ROTATE_MS);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function sync() { if (running()) start(); else stop(); }

    // viewport observer
    if ("IntersectionObserver" in window && slides.length > 1) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; sync(); });
      }, { threshold: 0.4 });
      io.observe(card);
      card.__slIO = io;
    } else { inView = true; }

    // hover (desktop)
    media.addEventListener("mouseenter", function () { hovering = true; sync(); });
    media.addEventListener("mouseleave", function () { hovering = false; sync(); });

    // arrows
    var pbtn = $("[data-sl-prev]", card), nbtn = $("[data-sl-next]", card);
    if (pbtn) pbtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); stop(); prev(); start(); });
    if (nbtn) nbtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); stop(); next(); start(); });

    // touch swipe
    var tx = 0;
    media.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    media.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > SWIPE_MIN) { stop(); if (dx < 0) next(); else prev(); start(); }
    }, { passive: true });
  }

  /* ---------- swatches per card ---------- */
  function initSwatches(card) {
    var wrap = $("[data-sl-swatches]", card);
    if (!wrap) return;
    var firstImg = $("img[data-sl-first]", card) || $("[data-sl-slide] img", card);
    $$("[data-sl-swatch]", wrap).forEach(function (sw) {
      sw.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        $$("[data-sl-swatch]", wrap).forEach(function (x) { x.classList.remove("is-active"); });
        sw.classList.add("is-active");
        var img = sw.getAttribute("data-sl-img");
        if (firstImg && img) {
          firstImg.setAttribute("src", img);
          firstImg.removeAttribute("srcset");
        }
      });
    });
  }

  /* ---------- init (idempotent) ---------- */
  function initCard(card) {
    if (!card || card.__slInit) return;
    card.__slInit = true;
    initGallery(card);
    initSwatches(card);
  }

  function init(root) {
    root = root || document;
    if (root.matches && root.matches("[data-sl-card]")) initCard(root);
    $$("[data-sl-card]", root).forEach(initCard);
    paintAllWishes();
  }

  /* ---------- delegated: wishlist + quick add ---------- */
  document.addEventListener("click", function (e) {
    var wish = e.target.closest("[data-sl-wish]");
    if (wish) {
      e.preventDefault(); e.stopPropagation();
      var handle = wish.getAttribute("data-sl-wish");
      var arr = wishGet(); var i = arr.indexOf(handle);
      if (i > -1) { arr.splice(i, 1); } else { arr.push(handle); }
      wishSet(arr);
      paintWish(handle);
      toast(i > -1 ? "Removed from wishlist" : "Saved to wishlist");
      return;
    }

    var qadd = e.target.closest("[data-sl-qadd]");
    if (qadd) {
      e.preventDefault(); e.stopPropagation();
      if (qadd.classList.contains("is-loading")) return;
      var id = qadd.getAttribute("data-sl-variant");
      if (!id) { toast("Unavailable"); return; }
      qadd.classList.add("is-loading");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          qadd.classList.remove("is-loading");
          if (!res.ok) { toast(res.data.description || "Could not add"); return; }
          return fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              // No success toast: the drawer below is the confirmation.
              // integrate with host theme (Polka Tots) drawer if present
              if (window.PT && typeof window.PT.renderCart === "function") window.PT.renderCart(cart);
              if (window.PT && typeof window.PT.openCart === "function") window.PT.openCart();
              // namespaced event for any listener
              document.dispatchEvent(new CustomEvent("sl:cart:added", { detail: { variantId: id, cart: cart } }));
              // generic refresh hooks used by common themes
              document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            });
        })
        .catch(function () { qadd.classList.remove("is-loading"); toast("Network error"); });
      return;
    }
  });

  /* ---------- theme editor + lifecycle ---------- */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:reorder", function (e) { init(e.target); });
  document.addEventListener("shopify:block:select", function (e) { init(e.target); });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else { init(document); }

  window.SLCard = { init: init, toast: toast };
})();
